// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Button from '../../components/buttons/Button';
import Spinner from '../../components/loaders/Spinner';
import Icon from '../../components/icons/Icon';

// Styles
import './ExportPopupExportButton.scss';

const DOWNLOADING_STATUSES = {
    GENERATING: 'GENERATING',
    DOWNLOADING: 'DOWNLOADING',
    ERROR: 'ERROR',
};

const ExportPopupExportButton = (props) => {
    const { children, status, disabled, errorText, onClickFn } = props;

    if (status === DOWNLOADING_STATUSES.ERROR) {
        return (
            <div className="ExportPopupExportButton error">
                <Icon name="link-fail" />
                <span className="text">{errorText}</span>
            </div>
        );
    }

    if (status === DOWNLOADING_STATUSES.GENERATING || status === DOWNLOADING_STATUSES.DOWNLOADING) {
        const text = status === DOWNLOADING_STATUSES.GENERATING ? 'Generating' : 'Downloading';
        return (
            <div className="ExportPopupExportButton loading">
                <Spinner show />
                <span className="text">{text}</span>
            </div>
        );
    }

    return (
        <Button className="ExportPopupExportButton" onClick={!disabled ? onClickFn : null} disabled={disabled}>
            {children}
        </Button>
    );
};

ExportPopupExportButton.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    onClickFn: PropTypes.func,
    status: PropTypes.string,
    errorText: PropTypes.string,
    disabled: PropTypes.bool,
};

export default ExportPopupExportButton;
